import { Link } from 'react-router-dom';

export function Footer() {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { name: 'Instagram', url: 'https://instagram.com/aidreamspaces', icon: 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z' },
    { name: 'TikTok', url: 'https://tiktok.com/@tiktokbahe', icon: 'M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z' },
    { name: 'X', url: 'https://x.com/reluvetel', icon: 'M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z' },
    { name: 'Threads', url: 'https://threads.net/@aidreamspaces', icon: 'M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.472 12.01v-.017c.03-3.579.879-6.43 2.525-8.482C5.845 1.205 8.6.024 12.18 0h.014c2.746.02 5.043.725 6.826 2.098 1.677 1.29 2.858 3.13 3.509 5.467l-2.04.569c-1.104-3.96-3.898-5.984-8.304-6.015-2.91.022-5.11.936-6.54 2.717C4.307 6.504 3.616 8.914 3.589 12c.027 3.086.718 5.496 2.057 7.164 1.43 1.783 3.631 2.698 6.54 2.717 2.623-.02 4.358-.631 5.8-2.045 1.647-1.613 1.618-3.593 1.09-4.798-.31-.71-.873-1.3-1.634-1.75-.192 1.352-.622 2.446-1.284 3.272-.886 1.102-2.14 1.704-3.73 1.79-1.202.065-2.361-.218-3.259-.801-1.063-.689-1.685-1.74-1.752-2.96-.065-1.182.408-2.256 1.333-3.022.812-.672 1.927-1.09 3.222-1.208.924-.084 1.87-.05 2.814.101.026-.623.01-1.247-.047-1.867-.157-1.712-.763-2.442-2.108-2.523-.997-.06-1.848.234-2.395.828-.396.43-.612 1.003-.62 1.655l-2.12-.041c.03-1.146.435-2.14 1.173-2.878.925-.926 2.302-1.436 3.873-1.343 2.312.126 3.77 1.263 4.088 3.19.084.503.126 1.075.126 1.702 0 .206-.003.412-.01.617 1.387.655 2.458 1.652 3.093 2.919.744 1.48.883 3.628-.646 5.572-1.72 2.183-4.209 3.103-7.608 3.126zm1.677-10.542c-.806-.076-1.597-.064-2.354.034-.938.122-1.685.377-2.224.757-.511.36-.758.817-.723 1.337.038.564.334 1.04.834 1.343.535.325 1.249.512 2.01.527.996-.063 1.792-.358 2.367-.876.575-.518.903-1.224 1.004-2.157-.305-.102-.606-.2-.914-.279l.001-.002-.001.316z' },
  ];

  return (
    <footer className="border-t border-border/50 py-8 md:py-12">
      <div className="container mx-auto px-6 md:px-12 lg:px-24">
        <div className="flex flex-col items-center gap-6">
          {/* Logo */}
          <div className="flex items-center space-x-2">
            <span className="font-heading text-lg font-semibold">AIDreamSpaces</span>
          </div>

          {/* Social Links */}
          <div className="flex items-center space-x-4">
            {socialLinks.map((social) => (
              <a
                key={social.name}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary transition-colors p-2"
                data-testid={`social-${social.name.toLowerCase()}`}
                aria-label={social.name}
              >
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d={social.icon} />
                </svg>
              </a>
            ))}
          </div>
          
          {/* Navigation */}
          <div className="flex items-center space-x-6 text-sm text-muted-foreground">
            <Link
              to="/gallery"
              className="hover:text-foreground transition-colors"
              data-testid="footer-gallery"
            >
              Gallery
            </Link>
            <Link
              to="/search"
              className="hover:text-foreground transition-colors"
              data-testid="footer-search"
            >
              Search
            </Link>
            <Link
              to="/about"
              className="hover:text-foreground transition-colors"
              data-testid="footer-about"
            >
              About
            </Link>
            <Link
              to="/contact"
              className="hover:text-foreground transition-colors"
              data-testid="footer-contact"
            >
              Contact
            </Link>
          </div>
          
          <p className="text-sm text-muted-foreground">
            © {currentYear} AI Dream Spaces. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
